import { createClient, SupabaseClient } from '@supabase/supabase-js';

let supabaseInstance: SupabaseClient | null = null;
let isInitialized = false;

export function getSupabase(): SupabaseClient | null {
  if (isInitialized) {
    return supabaseInstance;
  }

  const url = process.env.SUPABASE_URL;
  const key = process.env.SUPABASE_ANON_KEY;

  if (!url || !key) {
    console.warn(
      "[SUPABASE] SUPABASE_URL atau SUPABASE_ANON_KEY belum diatur di .env. Caching resep dinonaktifkan."
    );
    isInitialized = true;
    return null;
  }

  try {
    supabaseInstance = createClient(url, key, {
      auth: {
        persistSession: typeof window !== 'undefined',
        autoRefreshToken: typeof window !== 'undefined',
      }
    });
    console.log("[SUPABASE] Supabase Client berhasil dihubungkan untuk caching cerdas.");
  } catch (error) {
    console.error("[SUPABASE] Gagal menginisialisasi client Supabase:", error);
  }

  isInitialized = true;
  return supabaseInstance;
}

/**
 * SQL Migration Helper (Untuk disalin user ke SQL Editor Supabase):
 * 
 * -- Buat tabel untuk menampung cache resep yang sudah digenerate AI
 * CREATE TABLE IF NOT EXISTS public.recipe_cache (
 *     id UUID DEFAULT gen_random_uuid() PRIMARY KEY,
 *     hash_key TEXT UNIQUE NOT NULL,
 *     type TEXT NOT NULL,
 *     baby_age INT,
 *     texture TEXT,
 *     ingredients TEXT[],
 *     pantry_hash TEXT,
 *     payload JSONB NOT NULL,
 *     created_at TIMESTAMP WITH TIME ZONE DEFAULT timezone('utc'::text, now()) NOT NULL
 * );
 * 
 * CREATE INDEX IF NOT EXISTS idx_recipe_cache_hash ON public.recipe_cache(hash_key);
 * CREATE INDEX IF NOT EXISTS idx_recipe_cache_ingredients ON public.recipe_cache USING gin(ingredients);
 * 
 * -- Buat tabel user profiles untuk autentikasi dan pencadangan profil pengguna
 * CREATE TABLE IF NOT EXISTS public.user_profiles (
 *     id UUID REFERENCES auth.users(id) ON DELETE CASCADE PRIMARY KEY,
 *     caregiver_name TEXT,
 *     baby_name TEXT,
 *     baby_dob TEXT,
 *     family_size INT,
 *     city TEXT,
 *     first_join_date TIMESTAMP WITH TIME ZONE,
 *     last_accessed_date TIMESTAMP WITH TIME ZONE,
 *     plan TEXT DEFAULT 'free'
 * );
 */
